
<template>
    <div class="position-relative">
        <slot></slot>
    </div>
</template>

<script>
    import autoComplete from '@tarekraafat/autocomplete.js';

    export default {
        data: function () {
            return {

            };
        },
        props: ["shippingAddressModel"],
        mounted: function () {
            var vm = this;
            var fieldName = "label";
            const autoCompleteJS = new autoComplete({
                selector: "#City",
                data: {
                    //src: async () => {
                    //    document.querySelector("#City").setAttribute("placeholder", "טוען...");

                    //    var value = document.querySelector("#City").value;

                    //    const source = await fetch('https://data.gov.il/api/3/action/datastore_search?q=' +
                    //        ('{"שם_ישוב":"\'' + value + '\':*"' + '}') +
                    //        '&resource_id=d4901968-dad3-4845-a9b0-a57d027f11ab&limit=10&plain=false', { mode: 'cors' });
                    //    const data = await source.json();

                    //    document.querySelector("#City").setAttribute("placeholder", autoCompleteJS.placeHolder);

                    //    return data.result.records;
                    //},
                    src: async () => {
                        // Loading placeholder text
                        document.querySelector("#City").setAttribute("placeholder", "טוען...");
                        // Fetch External Data Source
                        const endpoint = window.location.protocol + "//" + location.host + "/GetSitiesAutocomplete";
                        /* const source = await fetch(endpoint + "?language2Leters=" + window.languageUniqueSeoCode + "&keyword=" + document.querySelector("#City").value);*/
                        const source = await fetch(endpoint + "?language2Leters=" + "he" + "&keyword=" + document.querySelector("#City").value);
                        const data = await source.json();
                        // Post Loading placeholder text

                        document.querySelector("#City").setAttribute("placeholder", "bla");
                        // Returns Fetched data
                        return data;
                    },
                    keys: ["label"],
                    key: [fieldName],
                    //cache: true,
                },
                searchEngine: "loose",
                placeHolder: "",
                maxResults: 5,
                highlight: true,
                debounce: 300,
                threshold: 1
            });

            document.querySelector("#City").addEventListener("selection", function (event) {
                vm.$props.shippingAddressModel.city = event.detail.selection.value["label"].trim().replace(")", "))").replace("(", ")").replace("))", "(");
                console.log(event.detail);
            });
        },
        methods: {
        },
        computed: {
        }
    }
</script>